import React, { useState, useEffect } from 'react';
import { DateTime } from 'luxon';
import { Link } from 'react-router-dom';
import moment from 'moment';
import ReactDOM from 'react-dom';
import parse from 'html-react-parser';
import FullCalendar from '@fullcalendar/react';
import timeGridPlugin from '@fullcalendar/timegrid';
import interactionPlugin from '@fullcalendar/interaction';
import { Select, MenuItem, CircularProgress } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import MenuIcon from '@material-ui/icons/Menu';
import { useSnackbar } from 'notistack';
import queryString from 'query-string';
import CalendarDatePicker from '../../components/CalendarDatePicker';
import AvailabilityModal from './components/AvailabilityModal';
import AppointmentModal from './components/AppointmentModal';
// import socket from '../../socket/socketConfig';
import { fetchProviderAppointments, fetchProvider } from '../../services/api';
import {
  transformAppointmentToFullCalendarEvent,
  dateTransform,
  transformAvailabilityToFullCalendarEvent,
  transformToServerEvent,
} from './utils';
import * as adminApi from '../../services/api/admin';
import * as authApi from '../../services/api/auth';
import './styles.scss';
import './styles.css';
import { useLocation } from 'react-router-dom';

function WeekView(props) {
  const {
    location,
    history,
    classes: { mainWrapper, main, mainLoading },
  } = props;

  //Auto-refresh fetchAdminAvailability and fetchAppointments using Socket.io
  // const socketUpdate = data => {
  //   console.log(
  //     'two-weekview--Ids',
  //     data.id,
  //     currentUserId && currentUserId.id
  //   );
  //   if (data.id === currentUserId.id) {
  //     if (data.message === 'auto-refresh-Availability') {
  //       return fetchAdminAvailability(true);
  //     } else {
  //       return fetchAppointments();
  //     }
  //   }
  // };

  const { enqueueSnackbar } = useSnackbar();
  const [isLoading, setIsLoading] = useState(true);
  const [openAppointmentModal, setOpenAppointmentModal] = useState(false);
  const [openAvailabilityModal, setOpenAvailabilityModal] = useState(false);
  const [appointmentEvents, setAppointmentEvents] = useState([]);
  const [availabilityEvents, setAvailabilityEvents] = useState([]);
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [provider, setProvider] = useState({});
  const [currentUserId, setCurrentUserId] = useState('');
  const [currentPractice, setCurrPractice] = useState({});
  const [viewableDateRange, setViewableDateRange] = useState(null);
  const [selectedTenancyType, setSelectedTenancyType] = useState("both");
  const [selectedZipCode, setSelectedZipCode] = useState('')
  const [selectedAvailability, setSelectedAvailability] = useState({
    providerId: '',
    tenancyId: '',
    start: dateTransform(new Date()),
    end: dateTransform(new Date()),
    availability: false,
    scheduleId: '',
    telemedicineId: ''
  });
  const [selectedAppt, setSelectedAppt] = useState({
    id: '',
    time: '',
    durationMinutes: 0,
    tenancyLocation: '',
    tenancyId: '',
    patientId: '',
    patientName: '',
    patientDOB: '',
    patientEmail: '',
    patientPhone: '',
    providerFullTitle: '',
    patientTebraId:'-',
  });
  const [toggle, setToggle] = useState(false);
  // const [timeErrorMessage, setTimeErrorMessage] = useState(false);
  const calendarRef = React.createRef();
  const [selectedView, setSelectedView] = useState("Week View");

  useEffect(() => {
    (async () => {
      let { provider_id: providerId } = queryString.parse(location.search);
      setIsLoading(true);
      const user = await authApi.fetchCurrentUser();
      let practice = await authApi.fetchCurrentPractice();

      //Omit folowing providers showing up in calender drop down as per client request.
      const omittedProviders = [
        'b557d646-9d11-472f-abc1-ad7926fe4660',
        '1e9a4b66-eaba-497f-b157-92ddc610d215',
        '5ee221d3-fda0-4d10-be3c-ca0f5f6c634e',
        '05b82538-6fa6-4629-a47a-85867dc1b427',
        '7934814f-abcc-42e7-9eae-f4381bfa60f7',
        '538618e5-3b58-4ed7-aecb-9dca60295cbb',
      ];

      // let updatedData = {
      //   ...practice,
      //   providers: practice.providers.filter(
      //     (provider) => !omittedProviders.includes(provider.id)
      //   ),
      // };

      let providersList = practice.providers.filter(
        (provider) => !omittedProviders.includes(provider.id)
      );
      let sortAndGroupProvidersList = sortAndGroupProviders(providersList);
      // updatedData.providers.sort((a,b)=> a.firstName.localeCompare(b.firstName));
      let updatedData = {
        ...practice,
        providers: sortAndGroupProvidersList,
      };

      practice = updatedData;
      setCurrPractice(practice);

      // get the users provider id, or the first of their practice's provider ids
      providerId = providerId || user.provider.id || practice.providers[0].id;
      setCurrentUserId(user);
      if (providerId) {
        const fetchedProvider = await fetchProvider(providerId);
        setProvider(fetchedProvider);
      }
      setIsLoading(false);
    })();
  }, []);

  useEffect(() => {
    (async () => {
      if (provider && provider.id && viewableDateRange) {
        setIsLoading(true);
        fetchAdminAvailability();
        fetchAppointments();
        setIsLoading(false);
        // socket.off('message').on('message', data => {
        //   socketUpdate(data);
        // });
      }
    })();
  }, [viewableDateRange, provider]);

  const sortAndGroupProviders = (updatedData) => {
    const priorityGroups = [
      ['Dr Pearl Lui, MD', 'Olivia Mannix, PA-C', 'Eric Nguyen, PA-C'],
      ['Dr John Meer, MD', 'Gaia Mistriel, PA', 'PA Zoe Rouder, PA-C'],
      [
        'Christine Pipchick, PA',
        'Suhasini Neelam Satish, PA',
        'Dr Maria Sequeira, MD',
      ],
      [
        'Dr. Lovonne Brown, MD',
        'Emma Poulshock, PA-C',
        'Dr Zinoviy Gutkovich, MD',
      ],
      ['James Lauren, NP', 'NP Karyl Soto, NP'],
      [
        'Dr. Jenny Gerner, MD',
        'Dr. Omar Hawasli, MD',
        'Dr Nadav Wallach, MD',
        'Shayna LaSala, NP',
        'Dr Ann Marie Gustafson, MD',
      ],
      ['Dr Marc Cimmino, DO', 'Dr. Wendy VanDyke, DO', 'Rachel Khaldar, PA'],
      [
        'Rebecca Wine, PA',
        'Nicole Kopchak, PA-C',
        'Shirina Braun, PA',
        'Dr Robert Schranze, MD',
        'NP Valerie Naggie, PMHNP-BC',
        'Dr Angelina Singh, DO',
      ],
    ];

    // Step 1: Sort everything by name
    const sorted = updatedData.sort((a, b) =>
      a.firstName.localeCompare(b.firstName)
    );

    // Step 3: map for quick lookup
    const providerMap = new Map(sorted.map((p) => [p.name, p]));

    // Step 4: extract priority providers in exact order
    const groupedPriority = [];
    const usedNames = new Set();

    priorityGroups.forEach((group) => {
      const groupItems = [];

      group.forEach((name) => {
        if (providerMap.has(name)) {
          groupItems.push(providerMap.get(name));
          usedNames.add(name);
        }
      });

      if (groupItems.length) {
        groupedPriority.push(...groupItems);
      }
    });

    // Step 5: remaining providers (not in priority list)
    const remaining = sorted.filter((p) => !usedNames.has(p.name));

    // Step 6: final result
    return [...remaining, ...groupedPriority];
  };

  const onSave = async () => {
    // Check user timezone
    const currentUserTimezone =
    Intl.DateTimeFormat().resolvedOptions().timeZone;
    if (currentUserTimezone !== 'America/New_York') {
      alert(
        '⚠️ Time Zone Mismatch Detected:\n' +
          'Kindly switch your system time zone to "America/New_York, EST" to proceed further.'
      );
      setOpenAvailabilityModal(false);
      return;
    }

    setIsLoading(true);
    try {
      if (
        moment(selectedAvailability.start).isSameOrAfter(
          moment(selectedAvailability.end)
        )
      ) {
        enqueueSnackbar(
          `Availability 'Start Time' must be before 'End Time.'`,
          {
            preventDuplicate: true,
            autoHideDuration: 3000,
          }
        );
      } else if (
        moment(selectedAvailability.start).format('HH:mm') < '23:00' &&
        moment(selectedAvailability.end).format('HH:mm') > '23:00'
      ) {
        // setTimeErrorMessage(true);
        enqueueSnackbar(`No Availability for after 11 pm`, {
          preventDuplicate: true,
          autoHideDuration: 5000,
        });
      } else if (moment(selectedAvailability.start).format('HH:mm') > '23:00') {
        enqueueSnackbar(`No Availability for after 11 pm`, {
          preventDuplicate: true,
          autoHideDuration: 5000,
        });
      } else {
        await adminApi.createAvailability(
          transformToServerEvent(selectedAvailability)
        );
        setAvailabilityEvents([
          ...availabilityEvents,
          transformAvailabilityToFullCalendarEvent(selectedAvailability),
        ]);
        onClose();
        // socket.emit('message', {
        //   message: 'auto-refresh-Availability',
        //   id: currentUserId && currentUserId.id,
        // });
      }
    } catch (err) {
      enqueueSnackbar(`Creating Availability failed. Please try again.`);
    }
    setIsLoading(false);
  };

  const onDelete = async () => {
    setIsLoading(true);
    try {
      await adminApi.deleteAvailability(
        transformToServerEvent(selectedAvailability)
      );
      setAvailabilityEvents(
        availabilityEvents.filter(availabilityEvent => {
          return (
            JSON.stringify(availabilityEvent) !==
            JSON.stringify(selectedAvailability)
          );
        })
      );
      onClose();
      // socket.emit('message', {
      //   message: 'auto-refresh-Availability',
      //   id: currentUserId && currentUserId.id,
      // });
    } catch (err) {
      enqueueSnackbar('Deleting Availability failed. Please try again.');
    }
    setIsLoading(false);
  };

  const fetchAppointments = async () => {
    try {
      const appointments = await fetchProviderAppointments(
        provider.id,
        viewableDateRange.start,
        viewableDateRange.end,
        selectedTenancyType,
        selectedZipCode
      );
      setAppointmentEvents(
        appointments.map(transformAppointmentToFullCalendarEvent)
      );
    } catch (err) {
      //todo add err logging here
      enqueueSnackbar('Fetching Booked Appointments failed. Please try again.');
    }
  };

  const handleDateChange = date => {
    setSelectedDate(date);
    const calendarApi = calendarRef.current.getApi();
    calendarApi.gotoDate(date);
  };

  const calendarAvailabilitySelected = event => {
    // const startTimeEvent = dateTransform(event.start);
    // const endTimeEvent =  dateTransform(event.end);
    // if (
    //   moment(startTimeEvent)
    //     .startOf('day')
    //     .hours(23) ||  moment(endTimeEvent)
    //     .startOf('day')
    //     .hours(23)
    // ) {
    //   console.log('event>>>>>>>', startTimeEvent);
    // }
    const { extendedProps = {} } = event;
    const { tenancyId = '', providerId = '', scheduleId = '' } = extendedProps;
    setSelectedAvailability({
      ...selectedAvailability,
      start: dateTransform(event.start),
      end: dateTransform(event.end),
      tenancyId,
      providerId: providerId || provider.id,
      scheduleId: scheduleId
    });
    setOpenAvailabilityModal(true);
  };

  const calendarAppointmentSelected = event => {
    const { extendedProps = {} } = event;
    const {
      tenancyLocation = '',
      tenancyId = '',
      providerFullTitle = '',
      patientId = '',
      patientName = '',
      patientDOB = '',
      patientEmail = '',
      patientPhone = '',
      patientTebraId = '-'
    } = extendedProps;

    setSelectedAppt({
      ...selectedAppt,
      time: event.start,
      durationMinutes:
        (new Date(event.end).getTime() - new Date(event.start).getTime()) /
        1000 /
        60,
      id: event.id,
      tenancyLocation,
      tenancyId,
      patientId,
      patientName,
      providerFullTitle,
      patientEmail,
      patientPhone,
      patientDOB,
      patientTebraId
    });
    setOpenAppointmentModal(true);
  };

  const onCalendarClicked = info => {
    const { event } = info;
    if (event.extendedProps && event.extendedProps.availability) {
      calendarAvailabilitySelected(event);
    }

    if (event.extendedProps && event.extendedProps.appointment) {
      calendarAppointmentSelected(event);
    }
  };

  const onTimeChange = (type, time) => {
    const dateTime = moment(time);
    setSelectedAvailability({
      ...selectedAvailability,
      [type]: dateTime.toDate(),
    });
  };

  const onTenancyChange = (tenancyId,telemedicineId) => {
    setSelectedAvailability({
      ...selectedAvailability,
      tenancyId,
      telemedicineId
    });
  };

  const fetchAdminAvailability = async fromSocket => {
    if (viewableDateRange || fromSocket) {
      try {
        const newAvailabilityEvents = await adminApi.fetchAdminAvailability({
          provider,
          dateRange: viewableDateRange,
          tenancyType: selectedTenancyType,
          zipcode: selectedZipCode
        });
        const transformedEvents = newAvailabilityEvents.map(event =>
          transformAvailabilityToFullCalendarEvent(event)
        );
        setAvailabilityEvents(transformedEvents);
      } catch (err) {
        enqueueSnackbar('Fetching Availability failed. Please try again.');
      }
    }
  };

  const onProviderChange = (providerId, practice) => {
    const providers = practice.providers;
    const selectedProvider = providers.find(prvdr => prvdr.id === providerId);

    setProvider(selectedProvider);

    history.push({ search: `?provider_id=${providerId}` });
  };

  const cancelAppointment = async () => {
    const appointmentId = selectedAppt.id;

    setIsLoading(true);
    try {
      await adminApi.cancelAppointmentFromAdmin(appointmentId);

      setAppointmentEvents(
        appointmentEvents.filter(event => event.id !== appointmentId)
      );
      // we shoudl fix this so availability shows up where the appt was

      onClose();
    } catch (err) {
      enqueueSnackbar('Failed to cancel appointment. Please try again.');
    }
    setIsLoading(false);
  };

  const onClose = () => {
    // setIsLoading(true);
    setSelectedAvailability({
      start: '',
      end: '',
      providerId: '',
      tenancyId: '',
      scheduleId: '',
      telemedicineId:''
    });
    setSelectedAppt({
      start: '',
      end: '',
      tenancyLocation: '',
      tenancyId: '',
      patientId: '',
      patientName: '',
      providerFullTitle: '',
      patientDOB: '',
      patientEmail: '',
      patientPhone: '',
      patientTebraId:'-',
    });
    setOpenAvailabilityModal(false);
    setOpenAppointmentModal(false);
    fetchAdminAvailability();
    fetchAppointments();
    // setIsLoading(false);
    // setTimeErrorMessage(false);
  };

  const showToggle = () => {
    setToggle(!toggle);
    if (toggle === true) {
      const getValue = document.getElementById('menu-bar');
      getValue.style.display = 'block';
      document.getElementById('contentBox').style.width = 'calc(100% - 255px)';
    } else {
      const getValue = document.getElementById('menu-bar');
      getValue.style.display = 'none';
      document.getElementById('contentBox').style.width = '100%';
    }
  };

  const events = [...appointmentEvents, ...availabilityEvents];
  
  const findView = useLocation();
  const isDayView = findView.pathname.includes('dayview');
  const isWeekView = findView.pathname.includes('weekview');

  return isLoading ? (
    <div className={mainWrapper}>
      <div className={mainLoading}>
        <div className="menu-bar">
          <Select value="Week View">
            <MenuItem
              component={Link}
              to="/admin/schedule/weekview"
              value="Week View"
            >
              Week View
            </MenuItem>
            <MenuItem
              component={Link}
              to="/admin/schedule/dayview"
              value="Day View"
            >
              Day View
            </MenuItem>
          </Select>
          <Select
            value={provider.id || ''}
            onChange={event =>
              onProviderChange(event.target.value, currentPractice)
            }
          >
            {(currentPractice.providers || []).map(provider => {
              return (
                <MenuItem value={provider.id} key={provider.id}>
                  {provider.name}
                </MenuItem>
              );
            })}
          </Select>
        </div>
        <CircularProgress size="20px" />
      </div>
    </div>
  ) : (
    <div className={mainWrapper}>
      <div className={main}>
        <div className="toogle-bar" onClick={showToggle}>
          <MenuIcon />
        </div>
        <div className="menu-bar">
          <Select value={selectedView}
              onChange={(e)=>setSelectedView(e.target.value)}>
            <MenuItem
              component={Link}
              to="/admin/schedule/weekview"
              value="Week View"
              disabled={selectedView === "Week View"}
            >
              Week View
            </MenuItem>
            <MenuItem
              component={Link}
              to="/admin/schedule/dayview"
              value="Day View"
              // disabled={selectedView === "Day View"}
            >
              Day View
            </MenuItem>
          </Select>
          <Select className='selectprovidername'
            value={provider.id || ''}
            onChange={event =>
              onProviderChange(event.target.value, currentPractice)
            }
          >
            {(currentPractice.providers || []).map(provider => {
              return (
                <MenuItem style={{padding:"5px",width:"100%",whiteSpace:"normal"}} value={provider.id} key={provider.id}>
                  {provider.name}
                </MenuItem>
              );
            })}
          </Select>
        </div>
        <CalendarDatePicker
          selectedDate={selectedDate}
          handleDateChange={handleDateChange}
          autoOk={true}
          label="Select a date"
        />
        <div className='weekView-main-div-calendar'>
        <FullCalendar
          ref={calendarRef}
          selectable
          timeZone="local"
          initialView="timeGridWeek"
          initialDate={selectedDate}
          select={calendarAvailabilitySelected}
          plugins={[timeGridPlugin, interactionPlugin]}
          // height="100%"
          contentHeight="auto"
          slotMinTime={'06:00:00'}
          slotMaxTime={'23:00:00'}
          events={events}
          allDaySlot={false}
          headerToolbar={false}
          // headerToolbar={false}
          slotDuration={'01:00:00'}
          snapDuration={'00:10:00'}
          eventClick={onCalendarClicked}
          datesSet={(calEvent) => {
            const { start, end } = calEvent;
            setViewableDateRange({ start, end });
          }}
          eventContent={info => {
            const data = info.event.title;
            return(
              <>
                {parse(data)}
                <div className="week-view">
                  <div className="tooltip">
                    <div>
                      {moment(info.event.start).format('hh:mm') +
                        '- ' +
                        moment(info.event.end).format('hh:mm') +
                        '-' +
                        info.event.title}
                    </div>
                  </div>
                </div>
              </>,
              info.el
            );
          }}
        />
        </div>
        
        {openAvailabilityModal && (
          <AvailabilityModal
            open={openAvailabilityModal}
            selectedAvailability={selectedAvailability}
            provider={provider}
            tenancies={provider.tenancies || []}
            onClose={onClose}
            onSave={onSave}
            onDelete={onDelete}
            onEventStartChange={value => onTimeChange('start', value)}
            onEventEndChange={value => onTimeChange('end', value)}
            onTenancyChange={onTenancyChange}
            // onTimeError={timeErrorMessage}
          />
        )}

        {openAppointmentModal && (
          <AppointmentModal
            open={openAppointmentModal}
            onClose={onClose}
            currentProvider={provider}
            selectedAppt={selectedAppt}
            cancelAppointment={cancelAppointment}
            refeshAppointments={fetchAppointments}
            currentUserId={currentUserId.id}
            currentUser={currentUserId}
          />
        )}
      </div>
    </div>
  );
}

const styles = () => ({
  mainWrapper: {
    display: 'flex',
    justifyContent: 'center',
    backgroundColor: 'white',
  },
  main: {
    width: '100%',
    height: '100%',
    padding: '2rem 2rem',
  },
  mainLoading: {
    width: '100%',
    height: '100%',
    padding: '2rem 2rem',
    display: 'flex',
    alignItems: 'center',
  },
});

export default withStyles(styles)(WeekView);
